import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { setStatusFail } from "../statusFail/statusFailSlice";

const initialState = {
  profileData: null,
  loading: false,
  error: null,
};

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;
 
export const fetchUserProfile = createAsyncThunk(
  "profile/fetchUserProfile",
  async ({ userId, accessToken, tenantId,navigate}, { rejectWithValue,dispatch }) => {
    Cookies.set("Token",accessToken);
    Cookies.set("UserId",userId);
    Cookies.set("TenantId", tenantId);
    try {
      const response = await axios.get(
        `${ACCOUNTS_URL}/profiles/user-profile/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            usertype: "provider",
            tenantId,
          },
        }
      );
   
      Cookies.set("Token", response.data.data.access_token);
      Cookies.set("TenantId", tenantId);
      Cookies.set("UserId", userId);
      localStorage.setItem(
        "admin_profile",
        JSON.stringify(response.data.data.profile)
      );
     
      return response.data.data.profile;
    } catch (error) {
      console.log(error)
     let message=  error?.response?.data?.error?.message || error.response?.data?.message || "Something went wrong"
      let route=  "/unauthorized"

      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }else if (!error.response || error.response.status >= 500) {
        // Network blip or server error: keep the session and let the user retry instead of logging them out.
        toast.error("The service is temporarily unavailable. Please refresh in a moment.");
      }else{
        navigate(route)
      }
      return rejectWithValue(message);
    }
  }
);
export const updateLastApp =
  ({ userId, body }) =>
  async () => {
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/lastapp/${userId}`,
        body
      );
      return response;
    } catch (error) {
      return error.response;
    }
  };

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: { updateProfileIMage: (state, action) => {
    state.profileData.imageUrl = action.payload
  }},
  
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.tenantObjects=null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profileData = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        
      });
  },
});

export const { updateProfileIMage } = profileSlice.actions
export default profileSlice.reducer;
